import $command from '@/utils/command'
import globalActions from '@/actions'
const state = {
	tree: [],
	list: [],
	current: {},
	root:{},
	subMenuVisable:true,
}
const mutations = {
	updateTree: (state, data) => {
		state.tree = data
		globalActions.setGlobalState({
			menu: state
		});
	},
	updateList: (state, data) => {
		state.list = data
		globalActions.setGlobalState({
			menu: state
		});
	},
	updateCurrent: (state, data) => {
		state.current = data
		
		let root = data;
		
		if(data.parents && data.parents.length > 0){
			root = data.parents[data.parents.length - 1]
		}
		state.root = root
		globalActions.setGlobalState({
			menu: state
		});
	}
}
const actions = {
	async get({
		commit
	}) {
		if (state.tree.length == 0) {
			const result = await $command.execute({
				api: "/core-merch-api/sys/getMenu",
				parameter: {}
			})
			
			let root = result.data;
			let tree = root.items;
			let list = [];
			toList(list, root)//将树型结构转换成列表结构
			setParent(list);  //设置各个节点的父节点
			commit('updateTree', tree)
			commit('updateList', list)
		}
		return state
	},
}
function setParent(list){
	list.forEach(node => {
		node.parents = [];
		let pid = node.parentId
		while(pid != 0){
			var parentArr = list.filter(item => item.id === pid);
			if(parentArr && parentArr.length > 0){
				parent = parentArr[0]
				node.parents.push(parent)
				pid = parent.parentId
			}
		}
	})
}

function toList(list, tree) {
	list.push({
		feature: tree.feature,
		icon: tree.icon,
		id: tree.id,
		name: tree.name,
		parentId: tree.parentId,
		url: tree.url,
		items:tree.items
	})
	if (tree.items && tree.items.length > 0) {
		tree.items.forEach(e => {
			toList(list, e)
		})
	}
}

export default {
	namespaced: true,
	mutations,
	state,
	actions
}